module.exports = __webpack_public_path__ + "static/media/Hey Sam, welcome to Troopr.fa0756ea.svg";